var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "k-drop-hint k-drop-hint-h",
      style: {
        position: "absolute",
        "z-index": 20000,
        top: _vm.targetTopOffset + "px",
        left: _vm.targetLeftOffset + "px"
      }
    },
    [
      _c("div", { staticClass: "k-drop-hint-start" }),
      _vm._v(" "),
      _c("div", { staticClass: "k-drop-hint-line" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }